"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNode = exports.getMerkleTreeRootHash = exports.decodeBase64URL = exports.encodeBase64Url = exports.arrayBufferToHex = exports.decompressData = exports.compressData = exports.ensureUint8Array = exports.ensureArrayBuffer = exports.ensureBase64 = exports.base64ToArrayBuffer = exports.arrayBufferToBase64 = void 0;
const fflate = __importStar(require("fflate"));
const index_1 = require("../index");
const arrayBufferToBase64 = (buffer) => {
    return Buffer.from(buffer).toString("base64");
};
exports.arrayBufferToBase64 = arrayBufferToBase64;
const base64ToArrayBuffer = (base64) => {
    return Buffer.from(base64, "base64");
};
exports.base64ToArrayBuffer = base64ToArrayBuffer;
const ensureBase64 = (data) => {
    return typeof data === "string" ? data : (0, exports.arrayBufferToBase64)(data);
};
exports.ensureBase64 = ensureBase64;
const ensureArrayBuffer = (data) => {
    return typeof data === "string" ? (0, exports.base64ToArrayBuffer)(data) : data;
};
exports.ensureArrayBuffer = ensureArrayBuffer;
const ensureUint8Array = (data) => {
    return data instanceof Uint8Array
        ? data
        : typeof data === "string"
            ? new Uint8Array((0, exports.base64ToArrayBuffer)(data))
            : data instanceof ArrayBuffer
                ? new Uint8Array(data)
                : data;
};
exports.ensureUint8Array = ensureUint8Array;
const compressData = (binary) => {
    return fflate.gzipSync((0, exports.ensureUint8Array)(binary));
};
exports.compressData = compressData;
const decompressData = (binary) => {
    return fflate.decompressSync((0, exports.ensureUint8Array)(binary));
};
exports.decompressData = decompressData;
const arrayBufferToHex = (buffer) => {
    return [...new Uint8Array(buffer)]
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
};
exports.arrayBufferToHex = arrayBufferToHex;
const encodeBase64Url = (base64) => {
    return base64.replace(/\+/g, "-").replace(/\//g, "_");
};
exports.encodeBase64Url = encodeBase64Url;
const decodeBase64URL = (input) => {
    return input.replace(/_/g, "/").replace(/-/g, "+");
};
exports.decodeBase64URL = decodeBase64URL;
const getMerkleTreeRootHash = (leaves) => __awaiter(void 0, void 0, void 0, function* () {
    let hashes = [...leaves];
    while (hashes.length != 1) {
        let pair;
        const newHashes = [];
        for (let i = 0; i < hashes.length; i++) {
            const hash = hashes[i];
            pair = pair ? Buffer.concat([pair, hash]) : hash;
            if (i % 2) {
                newHashes.push(yield index_1.CryptoService.SHA256(pair));
                pair = null;
            }
            else {
                // If array has odd items, transfer the last one to the upper level of the tree
                if (i === hashes.length - 1) {
                    newHashes.push(hash);
                }
            }
        }
        hashes = newHashes;
    }
    return hashes[0];
});
exports.getMerkleTreeRootHash = getMerkleTreeRootHash;
exports.isNode = typeof process !== "undefined" &&
    process.versions != null &&
    process.versions.node != null;
exports.default = {
    compressData: exports.compressData,
    decompressData: exports.decompressData,
    arrayBufferToHex: exports.arrayBufferToHex,
    arrayBufferToBase64: exports.arrayBufferToBase64,
    base64ToArrayBuffer: exports.base64ToArrayBuffer,
    ensureUint8Array: exports.ensureUint8Array,
    ensureArrayBuffer: exports.ensureArrayBuffer,
    ensureBase64: exports.ensureBase64,
};
